import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import wallet from './wallet';
import wallets from './wallets';
import setting from './setting';

const store = new Vuex.Store({
  modules: {
    wallet,
    wallets,
    setting
  }
});

export default store;